import {http} from "../../axios";

const mutationsSubscribeNames = [
  'setInputValue',
]

function getInitState() {
  return  {
    muted: false,
    pendingLoad: false,
    inputs: {
      age_not_important: {
        value: null
      },
      age_from: {
        value: null
      },
      age_to: {
        value: null
      },
      exp_not_important: {
        value: null
      },
      exp_from: {
        value: null
      },
      certificates: {
        value: null
      },
      language_know: {
        value: null
      },
      language_know_comment: {
        value: null
      },
      phform_not_important: {
        value: null
      },
      phform_weight: {
        value: null
      },
      phform_height: {
        value: null
      },
      phform_disability_allowed: {
        value: null
      },
      additional_requirements: {
        value: null
      }
    }
  }
}

export default {
  namespaced: true,
  state: {
    ...getInitState(),
    mutationsSubscribeNames,
    languagesList: [],
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setPendingLoad(state, value) {
      state.pendingLoad = value
    },
    setInputValue(state, {key, value}) {
      if (!state.inputs.hasOwnProperty(key)) return
      state.inputs[key].value = value
    },
    setLanguagesList(state, value) {
     state.languagesList = value
    }
  },
  actions: {
    load({dispatch, commit}) {
      commit('setPendingLoad', true)

      Promise.all([
        dispatch('loadLanguagesList')
      ]).then(() => {
        dispatch('setValueFromLists')
      }).finally(() => {
        commit('setPendingLoad', false)
      })
    },
    loadLanguagesList({commit}) {
      return http.get('/api/helper/selectbox/applicant_requirements_language').then(({data}) => {
        commit('setLanguagesList', data.data)
      })
    },

    setValueFromLists({state, commit}) {
      const keys = {
        'language_know': 'languagesList'
      }

      for (let [key, listKey] of Object.entries(keys)) {
        if (!isNaN(state.inputs[key].value)) {
          let value = state[listKey].find(item => item.id === state.inputs[key].value)
          if(value) commit('setInputValue', {key, value})
        }
      }

      commit('setMuted', false)
    },
    setVacancyValues({state, commit}, vacancy) {
      if (!vacancy.applicant_requirement) return
      const toBool = ['age_not_important', 'exp_not_important', 'phform_not_important', 'phform_disability_allowed']
      for (let key in state.inputs) {
        let value = vacancy.applicant_requirement[key]
        if(toBool.includes(key)) {
          value = !!value
        }

        commit('setInputValue', {key, value})
      }
    }
  },
  getters: {
    isFilledAge(state) {
      return state.inputs.age_not_important.value ||
        state.inputs.age_from.value !== null && state.inputs.age_to.value !== null
    },
    isFilledExp(state) {
      return state.inputs.exp_not_important.value ||
        state.inputs.exp_from.value !== null
    },
    isFilledLanguage(state) {
      return state.inputs.language_know.value !== null ||
        state.inputs.language_know_comment.value !== null
    },
    isFilledPhform(state) {
      return state.inputs.phform_not_important.value ||
        state.inputs.phform_weight.value !== null ||
        state.inputs.phform_height.value !== null ||
        state.inputs.phform_disability_allowed.value !== null
    }
  }
}
